import React from 'react'
import "./LoadingSpinner.scss";

export default function LoadingSpinner() {
  return (
    <div className="lds-facebook"><div></div><div></div><div></div></div>
  )
}
